const NV_LETTER_RATIO = 0.6648;
const INTELITE_LETTER_RATIO = 0.556;

const INTELITE_HEIGHT = { sm: 12, md: 16 };
const GAP = { sm: "gap-1.5", md: "gap-2.5" };

const INTELITE_BASELINE_SHIFT = "-15%";

export const BrandLockup = ({ size = "md", className = "" }) => {
  const inteliteHeight = INTELITE_HEIGHT[size] || INTELITE_HEIGHT.md;
  const letterHeight = inteliteHeight * INTELITE_LETTER_RATIO;
  const nvHeight = letterHeight / NV_LETTER_RATIO;

  return (
    <div className={`flex items-center ${GAP[size] || GAP.md} ${className}`}>
      <img
        src="/nuestra_vision_logo_texto+30_bajado.png"
        alt="Nuestra Visión"
        className="w-auto shrink-0"
        style={{ height: `${nvHeight}px` }}
      />
      <span className="w-1 h-1 rounded-full bg-black/25 shrink-0" />
      <img
        src="/intelite.png"
        alt="Intelite"
        className="w-auto shrink-0"
        style={{
          height: `${inteliteHeight}px`,
          transform: `translateY(${INTELITE_BASELINE_SHIFT})`,
        }}
      />
    </div>
  );
};
